import * as React from 'react';
import { Link } from 'react-router-dom';

export function NotFoundPage(): React.ReactElement {
  return (
    <main className="mx-auto flex min-h-screen max-w-md flex-col items-center justify-center px-4 text-center">
      <p className="text-sm font-medium text-brand-600">404</p>
      <h1 className="mt-2 text-2xl font-semibold text-neutral-900">
        Page not found
      </h1>
      <p className="mt-2 text-neutral-600">
        We couldn’t find the page you were looking for.
      </p>
      <Link
        to="/"
        className="mt-4 inline-flex items-center rounded-md bg-brand-600 px-4 text-base font-medium text-neutral-0 min-h-touch focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brand-500 focus-visible:ring-offset-2"
      >
        Back to dashboard
      </Link>
    </main>
  );
}
